<template>
  <div class="discount-modular">
    <MyHeader></MyHeader>
    <HeaderMenu></HeaderMenu>
    <ShareRight></ShareRight>
    <div class="header-modular">
      <img class="banner-bg-img" :src="bannerImg" alt="" @click="toUrl" />
      <!-- <img
        class="banner-bg-img"
        src="../assets/commodity-discount/discount-banner-img.png"
        alt=""
      />
      <div class="header-banner-discount-title-modular">
        <span class="discount-title1"
          >{{ $t("translateText.discountitemText1") }}
        </span>
        <span class="discount-title2">{{
          $t("translateText.discountitemText2")
        }}</span>
      </div> -->
    </div>
    <div class="body-modular">
      <div class="header-menu-bar-modular">
        <div class="menu-bar">
          <div class="menu-bar-item">
            <span class="top-bar-title" @click="toPersonCenter()">{{
              currLanguage == 3 ? "Home" : pageTextArr[4]
            }}</span>
            <img
              class="top-bar-icon"
              src="../assets/productDetail/top-bar-icon.png"
              alt=""
            />
          </div>
          <div class="menu-bar-item">
            <span class="top-bar-title">{{ pageTextArr[5] }}</span>
          </div>
        </div>
      </div>
      <!-- <div style="margin-top:20px;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          {{currLanguage==3?"Home":pageTextArr[4]}}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ pageTextArr[5] }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      </div> -->
      <div v-if="discountProductData.length == 0" class="my-evaluate-bodu-none">
        <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
        <p class="none-title">
          {{ pageTextArr[0] }}~
        </p>
      </div>
      <div v-else class="commodity-show-modular">
        <div
          class="commodity-show-item-modualr"
          v-for="(item, index) in discountProductData"
          :key="index"
        >
          <div class="commodity-show-item">
            <div
              class="commodity-show-item-img"
              @click="toProductDetail(item.id)"
            >
              <img class="commodity-show-img" :src="item.cover" alt="" />
            </div>
            <div class="commodity-show-item-msg">
              <div class="commodity-show-item-price">
                {{ currencySymbol
                }}{{
                  item.has_discount == 1 ? item.discount_price : item.price
                }}
                <span
                  class="commodity-show-item-discpunt-price"
                  v-if="item.has_discount == 1"
                >
                  {{ currencySymbol }}{{ item.price }}
                </span>
              </div>
              <div class="commodity-show-item-introduce">
                {{ currLanguage == 3 ? item.eng_title : item.title }}
              </div>
              <div class="commodity-show-item-evaluate">
                <div class="commodity-evaluate">
                  <!-- <span class="commodity-evaluate-num">{{
                    item.comment_num
                  }}</span>
                  <span class="commodity-evaluate-title">{{
                    $t("translateText.appraiseText")
                  }}</span> -->
                </div>
                <div class="commodity-coupon" v-if="item.has_coupon == 1">
                  {{ pageTextArr[1] }}
                </div>
              </div>
              <div class="commodity-show-item-operation">
                <div class="commodity-shop-cart" @click="toProductDetail(item.id)">
                  <span
                    class="add-cart-title"
                    >
                    {{ pageTextArr[2] }}
                    </span
                  >
                </div>
              </div>
              <div class="commodity-show-item-operation">
                <!-- <div
                  class="commodity-collection"
                  @click="productaddCollect(item.id, item.is_collect, index)"
                >
                  <img
                    class="collection-icon"
                    v-if="item.is_collect == 1"
                    src="../assets/home/collection-icon-2.png"
                    alt=""
                  />
                  <img
                    class="collection-icon"
                    v-else
                    src="../assets/home/collection-icon.png"
                    alt=""
                  />
                  <span class="collection-title">{{
                    $t("translateText.collectText")
                  }}</span>
                </div> -->
                <div class="commodity-shop-cart shop-cart-color" @click="productAddCart(item.id, item.number, 1, '', 1)">
                  <!-- <img
                    class="shop-cart-icon"
                    src="../assets/home/shop-cart-icon.png"
                    alt=""
                  /> -->
                  <span
                    class="add-cart-title"
                    >
                    <!-- {{ $t("translateText.addCartText") }} -->
                    {{ pageTextArr[3] }}
                    </span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-footer-modualr" style="text-align: center">
        <el-pagination
          :pager-count="11"
          :page-size="pagesize"
          :current-page="page"
          background
          layout="prev, pager, next"
          :total="pageCount"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      pagesize: 10,
      pageCount: 0,
      discountProductData: [], //折扣商品列表
      currencySymbol:
        localStorage.getItem("currencySymbol") == null
          ? "$"
          : localStorage.getItem("currencySymbol"),
      pageText: {
        discountitemText1: "折扣不断",
        discountitemText2: "钜惠连连",
        NoDataText: "暂无数据",
        drawbtnText: "领取",
        appraiseText: "评价",
        certificate: "券",
        collectText: "收藏",
        addCartText: "加入购物车",
      },
      pageTextArr: [
        '暂无数据',
        '优惠券',
        '产品细节',
        '加入购物车',
        '首页',
        '折扣商品'
      ],
      bannerImg: "",
      url: "",
      is_jump: null,
      itemName: "",
      currLanguage: localStorage.getItem('curLanguageType'),
    };
  },
  methods: {
    /**
     * 跳转优惠劵
     */
    toCoupon() {
      this.$router.push({
        path: "/commodityCoupon",
        query: { name: "", age: "" },
      });
    },

    /**
     * 商品加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      // if (this.$parent.tipsLogin()) return;
      that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum
      );
    },

    /**
     * 跳转商品详情
     */
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { product_id: id },
      });
    },

    /**
     * 折扣的商品列表
     */
    getProductListByDiscount() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
        exchange_rate: localStorage.getItem("currencyRate"),
      };
      this.$http.getProductListByDiscount(
        data,
        (res) => {
          if (res.ret == 1) {
            that.discountProductData = res.data;
            that.pageCount = parseInt(res.total);
            // api数据翻译
            that.translateApiData(res.data, "title");
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     *   加入收藏 取消收藏
     * @param {*} id
     * @param {*} status
     * @param {*} index
     */
    productaddCollect(id, status, index) {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      that.$parent.productCollect(
        id,
        status,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 设置收藏
            let newData = that.discountProductData[index];
            newData.is_collect = !status;
            this.$set(that.discountProductData, index, newData);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    /**
     * 翻译
     */
    pageTranslate() {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + "=" + that.pageText[key] + "&";
      }
      that.languageTranslate(transformText);
    },

    /**
     * 语言翻译 - 单个词语
     * @param {*} text
     */
    languageTranslate(text) {
      let that = this;
      this.$parent.translate(
        text,
        (res) => {
          // 处理页面死数据
          that.processingResults(res.data);
        },
        (res) => {}
      );
    },
    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");

      textArr.forEach((v, i) => {
        if (v != "") {
          // console.log('v-v',v.split('=')[0],v.split('=')[1]);
          for (const key in that.pageText) {
            if (v.split("=")[0] == key) {
              that.pageText[key] = v.split("=")[1];
              // console.log(' that.pageText[key]', that.pageText[key]);
            }
          }
        }
      });
      // console.log('pageText.magnanimityDrawTex',that.pageText.magnanimityDrawTex);
    },
    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, title) {
      let that = this;
      let newTextArr = [];
      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.languageTranslateByArr(newTextArr, title);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, title);
        },
        (res) => {}
      );
    },

    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title) {
      let that = this;
      data.forEach((v, i) => {
        that.discountProductData[i][title] = v.translation;
      });
    },
    /**
     * 分页点击
     * @param {*} val
     */
    handleCurrentChange(val) {
      let that = this;
      that.page = val;
      that.getProductListByDiscount();
    },
    /**
     * 获取banner列表
     */
    getBannerList(type) {
      let that = this;
      let data = {
        page: 1,
        pagesize: 3,
        type_id: type,
      };
      this.$http.getBannerList(data, (res) => {
        // console.log(res);
        if (res.ret == 1) {
          that.bannerImg = res.data[0].url;
          that.is_jump = res.data[0].is_jump;
          if (res.data[0].is_jump == 2) {
            that.url = res.data[0].jump_url;
          }
        }
      });
    },
    /**
     * banner 跳转
     */
    toUrl() {
      if (this.is_jump == 2) {
        window.open(this.url);
      } else {
        return;
      }
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr){
      let that = this
      let newpagetextArr = []
      that.translateByArr(arr,res=>{
        console.log("res",res);
        res.data.forEach((item,index)=>{
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
    },
    /**
     * 跳转首页
     */
     toPersonCenter() {
      this.$router.push({
        path: "/",
      });
    },
  },
  mounted() {
    let that = this;
    let url = window.location.href
    console.log("url",url)
    localStorage.setItem("url",url)
    // 折扣的商品列表
    that.getProductListByDiscount();
    // 翻译
    // that.pageTranslate();
    this.getBannerList(8);
    that.itemName = this.$route.query.name;
    that.languageTranslateByArrs(that.pageTextArr);
  },
};
</script>


// WEBPACK FOOTER //
// src/view/commodityDiscount.vue